export default "__VITE_PUBLIC_ASSET__63db1482__"